export const siteConfig = {
  appName: 'Bryanpark Veterinary Clinic',
  shortName: 'Bryanpark',
  packageName: 'bryanpark-veterinary-clinic',
  tagline: 'Thoughtful care for Bryanston companions',
  menuTagline: 'Bryanston veterinary care',
  footerDescription:
    'SAVC-registered veterinary care at 1 Moray Drive, Bryanpark / Bryanston. Trusted by local families for dogs, cats, and the hard days in between.',
  phoneDisplay: '011 706 2590',
  phoneHref: 'tel:+27117062590',
  email: 'bpvet@mweb.co.za',
  emailHref: 'mailto:bpvet@mweb.co.za',
  addressLine: '1 Moray Dr, Bryanston, Johannesburg, 2191',
  mapsUrl:
    'https://www.google.com/maps/place/Bryanpark+Veterinary+Clinic/@-26.0495469,27.9993204,17z',
  ratingValue: '4.8',
  reviewCount: '302',
  canonicalUrl: 'https://bryanpark-veterinary-clinic.pages.dev',
} as const;
